module.exports = new __parcel__URL__("news02.42707f0a.jpg").toString();